export interface TourStep {
  target: string;
  title: string;
  content: string;
  placement: "top" | "bottom" | "left" | "right";
}

export const TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="schedules-list"]',
    title: "Lista grafików",
    content:
      "Tu widzisz swoje grafiki. Kliknij na grafik, żeby zobaczyć szczegóły.",
    placement: "bottom",
  },
  {
    target: '[data-tour="create-schedule"]',
    title: "Nowy grafik",
    content:
      "W pełnej wersji ten przycisk pozwala utworzyć nowy grafik. W demo możesz przeglądać gotowe grafiki w różnych stanach procesu.",
    placement: "left",
  },
  {
    target: '[data-tour="schedule-search"]',
    title: "Wyszukiwanie",
    content:
      "Możesz przeszukiwać grafiki po nazwie lub opisie oraz filtrować je po kontekście.",
    placement: "bottom",
  },
];

export const SCHEDULE_DETAIL_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="schedule-header"]',
    title: "Nagłówek grafiku",
    content:
      "To jest pierwszy etap procesu - Konfiguracja. Tu widzisz nazwę i opis grafiku.",
    placement: "bottom",
  },
  {
    target: '[data-tour="locations-section"]',
    title: "Sekcja lokalizacji",
    content:
      "Tu możesz dodawać, edytować i usuwać lokalizacje przypisane do grafiku.",
    placement: "bottom",
  },
  {
    target: '[data-tour="workflow-stepper"]',
    title: "Etapy procesu",
    content:
      "Przejdź dalej przenosi Cię do następnego etapu procesu układania grafiku.",
    placement: "right",
  },
];

export const OPTIMIZATION_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="schedule-header"]',
    title: "Etap Optymalizacji",
    content:
      "To jest drugi etap procesu - Optymalizacja. Grafik jest już skonfigurowany i możesz przejść do układania zajęć w kalendarzu.",
    placement: "bottom",
  },
  {
    target: '[data-tour="open-calendar-btn"]',
    title: "Otwórz kalendarz",
    content:
      "Główna funkcja tego etapu - kliknij, aby otworzyć widok kalendarza tygodniowego, gdzie możesz układać zajęcia i uruchomić algorytm optymalizacji.",
    placement: "left",
  },
  {
    target: '[data-tour="locations-section"]',
    title: "Lokalizacje i grupy",
    content:
      "Na tym etapie nadal możesz przeglądać i zarządzać lokalizacjami oraz grupami przypisanymi do grafiku.",
    placement: "bottom",
  },
  {
    target: '[data-tour="export-button"]',
    title: "Eksport XLSX",
    content:
      "Możesz wyeksportować grafik do pliku Excel. W trybie demo pobierzesz przykładowy plik demonstracyjny.",
    placement: "bottom",
  },
  {
    target: '[data-tour="regress-button"]',
    title: "Powrót",
    content:
      "Przycisk Powrót przenosi Cię do grafiku z etapu Konfiguracji. Możesz też kliknąć (poprzedni) numer kroku w panelu, aby przejść do grafiku na danym etapie.",
    placement: "right",
  },
];

export const CALENDAR_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="calendar-view"]',
    title: "Kalendarz tygodniowy",
    content:
      "To jest widok kalendarza z rozłożonymi zajęciami. Każda kolorowa karta to jedno zajęcie - możesz je przeciągać myszką, żeby zmieniać dzień i godzinę lub kliknąć, aby edytować w popupie ze szczegółami.",
    placement: "top",
  },
  {
    target: '[data-tour="locked-lesson"]',
    title: "Blokowanie zajęć",
    content:
      "Ikona kłódki oznacza zablokowane zajęcia - nie można ich przenosić ani edytować. Kliknij kłódkę, aby odblokować zajęcia i umożliwić ich przenoszenie/edycję.",
    placement: "left",
  },
  {
    target: '[data-tour="optimize-button"]',
    title: "Uruchom optymalizację",
    content:
      "Kliknij, aby algorytm automatycznie ułożył zajęcia. W trybie demo, aplikacja załaduje losowy wariant - klikaj wielokrotnie, żeby zobaczyć różne rozkłady zajęć na kalendarzu.",
    placement: "right",
  },
  {
    target: '[data-tour="clear-optimization-button"]',
    title: "Wyczyść optymalizację",
    content:
      "Usuwa wszystkie zajęcia z kalendarza. W trybie demo, po odświeżeniu strony, dane wrócą do stanu początkowego.",
    placement: "right",
  },
  {
    target: '[data-tour="location-filter"]',
    title: "Filtr lokalizacji",
    content:
      "Grafik obejmuje wiele lokalizacji. Wybierz konkretną, aby zobaczyć tylko jej zajęcia, lub zostaw \"Wszystkie\" dla pełnego widoku.",
    placement: "bottom",
  },
  {
    target: '[data-tour="view-mode-selector"]',
    title: "Tryb widoku",
    content:
      "Przełączaj między widokiem dziennym, 3-dniowym i tygodniowym. Przy dużej liczbie zajęć węższy widok ułatwia czytanie.",
    placement: "bottom",
  },
  {
    target: '[data-tour="calendar-stats"]',
    title: "Statystyki",
    content:
      "Podsumowanie aktualnego stanu - liczba zajęć, zablokowanych slotów i grup. Aktualizuje się na bieżąco po każdej zmianie.",
    placement: "right",
  },
];

export const TEACHERS_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="open-calendar-teachers-btn"]',
    title: "Kalendarz prowadzących",
    content:
      "Kliknij, aby otworzyć kalendarz i przypisać prowadzących do zajęć - ręcznie lub automatycznie.",
    placement: "left",
  },
  {
    target: '[data-tour="locations-section"]',
    title: "Lokalizacje (tylko podgląd)",
    content:
      "Na tym etapie lokalizacje i grupy wyświetlają się w trybie tylko do odczytu - nie można ich edytować ani usuwać. Zmiany są możliwe tylko na etapie konfiguracji i optymalizacji.",
    placement: "top",
  },
];

export const TEACHERS_CALENDAR_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="calendar-view"]',
    title: "Kalendarz z prowadzącymi",
    content:
      "Na tym etapie kalendarz pokazuje zajęcia z przypisanymi prowadzącymi. Zajęcia są w trybie tylko do odczytu - nie można ich przenosić.",
    placement: "top",
  },
  {
    target: '[data-tour="teachers-panel"]',
    title: "Lista prowadzących",
    content:
      "Kliknij prowadzącego, a następnie kliknij zajęcia na kalendarzu, aby go przypisać. Prowadzący zostanie przypisany do wszystkich bloków danej grupy.",
    placement: "right",
  },
  {
    target: '[data-tour="optimize-teachers-button"]',
    title: "Automatyczna optymalizacja",
    content:
      "Algorytm automatycznie przypisze prowadzących do zajęć. W trybie demo, aplikacja losowo rotuje przypisania - klikaj wielokrotnie, żeby zobaczyć różne warianty.",
    placement: "right",
  },
  {
    target: '[data-tour="clear-teachers-button"]',
    title: "Wyczyść przypisania",
    content:
      "Usuwa wszystkich prowadzących z zajęć. Po odświeżeniu strony, dane wrócą do stanu początkowego.",
    placement: "right",
  },
  {
    target: '[data-tour="teacher-filter"]',
    title: "Filtr prowadzących",
    content:
      "Filtruj kalendarz po prowadzącym - wyświetl tylko zajęcia przypisane do wybranej osoby.",
    placement: "bottom",
  },
  {
    target: '[data-tour="calendar-stats"]',
    title: "Statystyki",
    content:
      "Podsumowanie aktualnego stanu - liczba zajęć, zablokowanych slotów i grup.",
    placement: "right",
  },
];

export const ACCEPTANCE_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="schedule-header"]',
    title: "Etap Akceptacji rodziców",
    content:
      "To jest czwarty etap procesu - Akceptacja rodziców. Grafik ma już przypisanych prowadzących i teraz możesz wysłać propozycje zajęć do rodziców w celu zebrania ich opinii.",
    placement: "bottom",
  },
  {
    target: '[data-tour="manage-approvals-btn"]',
    title: "Zarządzaj akceptacjami",
    content:
      "Kliknij, aby przejść do widoku zarządzania akceptacjami - tu tworzysz procesy akceptacji, wysyłasz maile do rodziców i śledzisz ich odpowiedzi.",
    placement: "left",
  },
  {
    target: '[data-tour="approve-all-btn"]',
    title: "Zatwierdź wszystkie grupy",
    content:
      "Skrót do zatwierdzenia wszystkich grup jednocześnie - pomija proces wysyłania emaili do rodziców. W trybie demo, ta akcja jest zablokowana.",
    placement: "left",
  },
  {
    target: '[data-tour="export-button"]',
    title: "Eksport XLSX",
    content:
      "Możesz wyeksportować grafik do pliku Excel. W trybie demo, pobierzesz przykładowy plik demonstracyjny.",
    placement: "bottom",
  },
  {
    target: '[data-tour="locations-section"]',
    title: "Lokalizacje (tylko podgląd)",
    content:
      "Na tym etapie lokalizacje i grupy wyświetlają się w trybie tylko do odczytu.",
    placement: "top",
  },
];

export const PARENT_APPROVALS_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="approval-header"]',
    title: "Panel akceptacji",
    content:
      "To jest strona zarządzania akceptacjami rodziców. Widzisz tu listę wszystkich grup z grafiku wraz ze statusem procesu akceptacji.",
    placement: "bottom",
  },
  {
    target: '[data-tour="approval-progress"]',
    title: "Postęp akceptacji",
    content:
      "Karta postępu pokazuje, ile grup zostało już zaakceptowanych, ile czeka na odpowiedź rodziców, a ile jeszcze nie rozpoczęło procesu.",
    placement: "bottom",
  },
  {
    target: '[data-tour="approval-filters"]',
    title: "Filtry",
    content:
      "Przeszukuj grupy po nazwie, filtruj po lokalizacji lub prowadzącym - ułatwia to zarządzanie przy dużej liczbie grup.",
    placement: "bottom",
  },
  {
    target: '[data-tour="approval-table"]',
    title: "Tabela grup",
    content:
      "Każdy wiersz to jedna grupa z informacjami o lokalizacji, prowadzącym, terminach zajęć i statusie akceptacji. W kolumnie Akcja możesz uruchomić proces akceptacji, pominąć go lub zobaczyć szczegóły.",
    placement: "top",
  },
];

export const FINALIZED_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="schedule-header"]',
    title: "Etap Finalizacji",
    content:
      "To jest piąty i ostatni etap procesu - Finalizacja. Grafik jest zatwierdzony, a Ty możesz uzupełnić dane grup i pobrać harmonogramy PDF (kalendarz zajęć i wydarzeń).",
    placement: "bottom",
  },
  {
    target: '[data-tour="open-finalization-btn"]',
    title: "Otwórz finalizację",
    content:
      "Kliknij, aby przejść do widoku finalizacji - tu uzupełnisz liczbę zajęć i datę startu dla każdej grupy, a następnie pobierzesz harmonogramy PDF (kalendarz zajęć i wydarzeń).",
    placement: "left",
  },
  {
    target: '[data-tour="export-button"]',
    title: "Eksport XLSX",
    content:
      "Możesz wyeksportować grafik do pliku Excel. W trybie demo, pobierzesz przykładowy plik demonstracyjny.",
    placement: "bottom",
  },
  {
    target: '[data-tour="locations-section"]',
    title: "Lokalizacje (tylko podgląd)",
    content:
      "Na tym etapie lokalizacje i grupy wyświetlają się w trybie tylko do odczytu.",
    placement: "top",
  },
];

export const FINALIZATION_PAGE_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="finalization-header"]',
    title: "Strona finalizacji",
    content:
      "Tu zarządzasz finalizacją grafiku - uzupełniasz dane grup i pobierasz harmonogramy PDF (kalendarz zajęć) z numeracją zajęć i datami.",
    placement: "bottom",
  },
  {
    target: '[data-tour="finalization-context-pdf"]',
    title: "Kalendarz kontekstu",
    content:
      "Pobierz PDF z kalendarzem dni wolnych i wydarzeń. Przydatny jako materiał referencyjny - pokazuje ferie, przerwy świąteczne i inne dni bez zajęć.",
    placement: "bottom",
  },
  {
    target: '[data-tour="finalization-info"]',
    title: "Jak to działa",
    content:
      "Uzupełnij liczbę zajęć w roku i datę startu - system automatycznie wyliczy datę końca, uwzględniając dni wolne z kalendarza kontekstu.",
    placement: "bottom",
  },
  {
    target: '[data-tour="finalization-groups"]',
    title: "Harmonogramy grup",
    content:
      "Lista wszystkich grup z grafiku. Grupy ze statusem \"Dane uzupełnione\" (zielony) mają gotowe dane i można pobrać dla ich kalendarz PDF. Kliknij \"Edytuj\" lub \"Uzupełnij\", aby zmienić dane finalizacji grup.",
    placement: "top",
  },
];

export const APPROVAL_DETAIL_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="approval-detail-header"]',
    title: "Szczegóły akceptacji",
    content:
      "To jest widok szczegółów procesu akceptacji dla konkretnej grupy. Widzisz tu nazwę grupy, status procesu i powiązany grafik.",
    placement: "bottom",
  },
  {
    target: '[data-tour="approval-detail-actions"]',
    title: "Akcje procesu",
    content:
      "Przyciski akcji: wyślij ponownie zaproszenia do wszystkich, zakończ proces z decyzją lub anuluj go. W trybie demo, większość akcji jest zablokowana.",
    placement: "bottom",
  },
  {
    target: '[data-tour="approval-detail-stats"]',
    title: "Statystyki odpowiedzi",
    content:
      "Podsumowanie odpowiedzi rodziców - ile osób zaakceptowało, odrzuciło, dodało uwagi i ile jeszcze oczekuje na odpowiedź.",
    placement: "bottom",
  },
  {
    target: '[data-tour="approval-detail-pending"]',
    title: "Oczekujące adresy",
    content:
      "Lista rodziców, którzy jeszcze nie odpowiedzieli. Możesz wysłać ponowne zaproszenie do konkretnej osoby lub podjąć decyzję w jej imieniu.",
    placement: "top",
  },
  {
    target: '[data-tour="approval-detail-responses"]',
    title: "Odpowiedzi rodziców",
    content:
      "Lista otrzymanych odpowiedzi z decyzjami rodziców, komentarzami i datami. Każda odpowiedź pokazuje czy rodzic zaakceptował, odrzucił lub dodał uwagi do propozycji.",
    placement: "top",
  },
];

export const DASHBOARD_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="dashboard-header"]',
    title: "Panel główny",
    content:
      "Witaj w BEE in TIME! To jest Twój panel główny - centrum zarządzania aplikacją. Stąd masz szybki dostęp do wszystkich modułów.",
    placement: "bottom",
  },
  {
    target: '[data-tour="schedules-hive"]',
    title: "Moduł Grafików",
    content:
      "Główny moduł aplikacji - zarządzanie grafikami zajęć. Widzisz tu statystyki: liczbę aktywnych grafików, grup i lokalizacji. Kliknij \"Otwórz Grafiki\", aby przejść do listy grafików.",
    placement: "bottom",
  },
  {
    target: '[data-tour="timesheet-hive"]',
    title: "Czas pracy",
    content:
      "Moduł ewidencji czasu pracy prowadzących i pracowników. Znajdziesz tutaj statystyki dot. przepracowanych godzin i zajęć w obecnym miesiącu oraz ilość wpisów, które czekają na zatwierdzenie.",
    placement: "bottom",
  },
  {
    target: '[data-tour="substitution-hive"]',
    title: "Zastępstwa",
    content:
      "Moduł zastępstw/odejść. Widzisz tutaj, ile było zastępstw w obecnym miesiącu i kto był najbardziej zastępowanym oraz zastępującym prowadzącym.",
    placement: "bottom",
  },
  {
    target: '[data-tour="charts-section"]',
    title: "Wykresy",
    content:
      "Sekcja wykresów dotyczących wpisów czasu pracy w obecnym miesiącu.",
    placement: "top",
  },
];

export const DICTIONARY_CONTEXTS_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="dictionary-header"]',
    title: "Bank danych",
    content:
      "To jest centralne miejsce zarządzania danymi używanymi w grafikach. Konteksty, lokalizacje, prowadzący i czasy transportu - wszystko w jednym miejscu.",
    placement: "bottom",
  },
  {
    target: '[data-tour="dictionary-tabs"]',
    title: "Zakładki",
    content:
      "Przełączaj między zakładkami, aby zarządzać różnymi typami danych. Dane ze słownika są współdzielone między grafikami.",
    placement: "bottom",
  },
  {
    target: '[data-tour="contexts-list"]',
    title: "Konteksty czasowe",
    content:
      "Konteksty określają ramy czasowe grafików - rok szkolny, semestr, kwartał itp. Jeden kontekst może być przypisany do wielu grafików.",
    placement: "top",
  },
  {
    target: '[data-tour="context-settings-btn"]',
    title: "Zarządzanie harmonogramem",
    content:
      "Kliknij ikonę koła zębatego, aby zarządzać harmonogramem kontekstu - dodawać dni wolne (ferie, święta) oraz wydarzenia specjalne, które wpływają na planowanie grafików.",
    placement: "left",
  },
];

export const DICTIONARY_LOCATIONS_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="locations-list"]',
    title: "Lokalizacje i sale",
    content:
      "Tu zarządzasz lokalizacjami i salami. Rozwiń lokalizację, aby zobaczyć jej sale. Możesz aktywować/dezaktywować lokalizacje i sale odpowiednim przyciskiem akcji.",
    placement: "top",
  },
  {
    target: '[data-tour="add-location-btn"]',
    title: "Dodaj lokalizację",
    content:
      "Utwórz nową lokalizację w słowniku - później przypiszesz ją do grafiku. W trybie demo, ta akcja jest zablokowana.",
    placement: "left",
  },
];

export const DICTIONARY_TEACHERS_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="teachers-list"]',
    title: "Lista prowadzących",
    content:
      "Tu zarządzasz prowadzącymi - ich danymi kontaktowymi, dostępnością i preferencjami lokalizacji. Prowadzący ze słownika mogą być przypisywani do zajęć w grafikach.",
    placement: "top",
  },
  {
    target: '[data-tour="add-teacher-btn"]',
    title: "Dodaj prowadzącego",
    content:
      "Dodaj nowego prowadzącego do słownika. W trybie demo, ta akcja jest zablokowana.",
    placement: "left",
  },
];

export const DICTIONARY_TRANSPORT_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="transport-matrix"]',
    title: "Czasy transportu",
    content:
      "Tabela/sekcja pokazuje czasy przejazdu między danymi lokalizacjami. Algorytm optymalizacji uwzględnia te czasy, aby uniknąć zbyt krótkich przerw między zajęciami prowadzącego w różnych lokalizacjach.",
    placement: "top",
  },
];

export const CHAT_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="chat-header"]',
    title: "Czat z rodzicami",
    content:
      "Komunikacja z rodzicami w grupach powiązanych z Twoimi zajęciami. Każda grupa ma swoje archiwum - gdy kurs się kończy, możesz zarchiwizować historię lub usunąć całą grupę.",
    placement: "bottom",
  },
  {
    target: '[data-tour="chat-create-btn"]',
    title: "Tworzenie grupy",
    content:
      "Nowa grupa jest tworzona ręcznie (wybierasz prowadzącego i rodziców) lub hurtowo z grafiku - wtedy system tworzy czat per aktywna grupa zajęciowa. Administrator dodaje rodziców do wybranej grupy.",
    placement: "left",
  },
  {
    target: '[data-tour="chat-stats"]',
    title: "Liczniki",
    content:
      "Szybki przegląd: liczba aktywnych grup i łączna liczba rodziców we wszystkich grupach. Pomaga ocenić, jak aktywny jest ten kanał komunikacji.",
    placement: "bottom",
  },
  {
    target: '[data-tour="chat-groups-list"]',
    title: "Lista grup",
    content:
      "Każdy kafel to jedna grupa - z nazwą, prowadzącym, liczbą uczestników i ostatnią aktywnością. Kliknij, aby wejść do rozmowy: ankiety, ogłoszenia, reakcje, załączniki, przypinanie, szablony odpowiedzi.",
    placement: "top",
  },
];

export const TIMESHEET_CALENDAR_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="timesheet-calendar-header"]',
    title: "Widok kalendarza",
    content:
      "Miesięczna siatka z wpisami czasu pracy. Strzałki i przycisk Dziś pozwalają szybko przełączać się między miesiącami.",
    placement: "bottom",
  },
  {
    target: '[data-tour="timesheet-calendar-filters"]',
    title: "Filtry kalendarza",
    content:
      "Zawęź widok do konkretnego pracownika, statusu lub typu wpisu. Przydaje się, gdy zespół ma dziesiątki wpisów w miesiącu - filtry zostają zachowane przy przełączaniu miesięcy.",
    placement: "bottom",
  },
  {
    target: '[data-tour="timesheet-calendar-grid"]',
    title: "Siatka kalendarza",
    content:
      "Każda komórka to dzień. Liczby godzin i kolorowe paski statusu pokazują szybkie podsumowanie. Kliknij pusty dzień, aby dodać wpis. Kliknij wpis, aby go edytować lub zobaczyć podgląd.",
    placement: "top",
  },
];

export const TIMESHEET_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="timesheet-header"]',
    title: "Ewidencja czasu pracy",
    content:
      "Tu pracownicy logują przepracowane godziny i zajęcia. Admin zatwierdza wpisy i zamyka miesiąc - wpisy z zamkniętego miesiąca są przygotowane do rozliczenia.",
    placement: "bottom",
  },
  {
    target: '[data-tour="timesheet-view-switcher"]',
    title: "Lista albo kalendarz",
    content:
      "Przełącz między widokiem tabelarycznym (z filtrami i akcjami), a kalendarzem miesięcznym, w którym klikasz w dzień, aby dodać wpis. 'Generuj z grafiku' automatycznie tworzy wpisy z zaplanowanych zajęć.",
    placement: "bottom",
  },
  {
    target: '[data-tour="timesheet-closure-panel"]',
    title: "Zamykanie miesiąca",
    content:
      "Admin widzi panel stanu miesiąca. Po zamknięciu miesiąca wpisy nie mogą być edytowane - wyjątek można zrobić dla konkretnego pracownika z raportu.",
    placement: "bottom",
  },
  {
    target: '[data-tour="timesheet-table"]',
    title: "Wpisy i flow statusów",
    content:
      "Każdy wpis przechodzi przez: Do wysłania → Przesłane → Zatwierdzone (lub Odrzucone z uzasadnieniem) → Rozliczone. Admin zaznacza wiele wpisów i zatwierdza je hurtowo. Kliknij Akcje → Podgląd, aby zobaczyć podgląd wpisu.",
    placement: "top",
  },
];

export const DEPARTURES_TAB_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="departures-filters"]',
    title: "Zakładka Odejścia",
    content:
      "Tu widzisz proces rozstania z prowadzącym - różni się od pojedynczego zastępstwa tym, że ktoś musi przejąć wszystkie jego grupy, a nie tylko jedne zajęcia. Filtry pomagają odszukać odejście w toku.",
    placement: "bottom",
  },
  {
    target: '[data-tour="departures-table"]',
    title: "Lista odejść",
    content:
      "Każdy wiersz to jedno odejście prowadzącego. Widzisz postęp - ile grup zostało już przejętych, a ile jeszcze czeka. Kliknij wiersz, aby otworzyć szczegóły odejścia z listą grup i kandydatami.",
    placement: "top",
  },
];

export const DEPARTURE_DETAIL_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="departure-detail-header"]',
    title: "Szczegóły odejścia",
    content:
      "Tu widzisz jedno odejście prowadzącego od początku do końca. Status w prawym górnym rogu mówi Ci na jakim etapie jest proces - od zgłoszenia, przez przydzielanie zastępstw do zakończenia.",
    placement: "bottom",
  },
  {
    target: '[data-tour="departure-detail-cards"]',
    title: "Informacje i postęp",
    content:
      "Po lewej: kto odchodzi i kiedy, plus ewentualna notatka o powodzie. Po prawej: pasek postępu (ile grup już przejętych) i akcje - wygeneruj rankingi, zakończ odejście, anuluj proces.",
    placement: "top",
  },
  {
    target: '[data-tour="departure-detail-groups"]',
    title: "Lista grup do przejęcia",
    content:
      "Wszystkie grupy, które trzeba przepiąć na nowego prowadzącego. Każdy wiersz ma swój status (oczekuje/propozycje wysłane/zakończone) i pokazuje kto ostatecznie przejął grupę. Kliknij w wiersz, aby otworzyć szczegółowe zgłoszenie dla tej grupy.",
    placement: "top",
  },
];

export const SUBSTITUTION_DETAIL_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="substitution-detail-header"]',
    title: "Szczegóły zgłoszenia",
    content:
      "Tutaj widzisz pełen kontekst jednego zastępstwa. Status w prawym górnym rogu mówi Ci, na jakim etapie jest proces - od oczekiwania po finalizację.",
    placement: "bottom",
  },
  {
    target: '[data-tour="substitution-detail-cards"]',
    title: "Informacje i akcje",
    content:
      "Po lewej: kto, kiedy, która grupa, notatka. Po prawej: przycisk Uruchom ranking (system znajdzie kandydatów), Wyślij propozycje (do wybranych nauczycieli), Ręczne przypisanie (z pominięciem rankingu) oraz Finalizuj (po akceptacji oferty).",
    placement: "top",
  },
  {
    target: '[data-tour="substitution-detail-offers"]',
    title: "Propozycje dla zastępców",
    content:
      "Lista kandydatów uszeregowana według trafności - sortowania po rangach, konfliktach z grafikiem, odległości. Zaznaczasz tych, do których chcesz wysłać propozycję zastępstwa.",
    placement: "top",
  },
];

export const SUBSTITUTIONS_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="substitutions-header"]',
    title: "Zastępstwa i odejścia",
    content:
      "Tu zarządzasz zgłoszeniami zastępstw oraz rozstań z prowadzącymi. System automatycznie rankinguje kandydatów i wysyła im propozycje (ścieżka automatyczna lub manualna).",
    placement: "bottom",
  },
  {
    target: '[data-tour="substitutions-create-btn"]',
    title: "Nowe zgłoszenie",
    content:
      "W pełnej wersji tym przyciskiem dodajesz nowe zgłoszenie zastępstwa lub odejścia. Formularz otworzy się normalnie - zapisanie pokaże informację demo.",
    placement: "left",
  },
  {
    target: '[data-tour="substitutions-tabs"]',
    title: "Dwa procesy, jeden widok",
    content:
      "Zakładka Zastępstwa - pojedyncze nieobecności (choroba, szkolenie). Zakładka Odejścia - rozstanie z prowadzącym, kiedy trzeba znaleźć zastępcę dla całego bloku grup.",
    placement: "bottom",
  },
  {
    target: '[data-tour="substitutions-stats"]',
    title: "Kluczowe metryki",
    content:
      "Na pierwszy rzut oka: ile zgłoszeń czeka, ile propozycji zostało wysłanych, ile zastępstw dopasowano w tym miesiącu i jak długo trwa średnio proces od zgłoszenia do dopasowania.",
    placement: "bottom",
  },
];

export const REPORTS_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="reports-header"]',
    title: "Raporty zespołu",
    content:
      "To centrum analityczne: czas pracy, zastępstwa, obciążenie prowadzących i komunikacja. Dane aktualizują się automatycznie z ewidencji, zastępstw/odejść oraz grup czatowych.",
    placement: "bottom",
  },
  {
    target: '[data-tour="reports-tabs"]',
    title: "Zakresy raportów",
    content:
      "Przełączaj się między widokami. Każda zakładka ma własny filtr (okres czasu) i pozwala wyeksportować dane do XLSX.",
    placement: "bottom",
  },
  {
    target: '[data-tour="reports-content"]',
    title: "Dane raportu",
    content:
      "Tu widzisz sumy godzin, koszty, statystyki zatwierdzonych godzin/zajęć i listę pracowników. Kliknij akcję 'Raport' na wierszu pracownika, aby otworzyć szczegółowy raport dla konkretnej osoby.",
    placement: "top",
  },
];

export const EMPLOYEES_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="employees-header"]',
    title: "Zarządzanie zespołem",
    content:
      "Tu widzisz listę pracowników z rolami i statusami. Każdy pracownik może być prowadzącym zajęcia oraz mieć własne stawki miesięczne.",
    placement: "bottom",
  },
  {
    target: '[data-tour="employees-add-btn"]',
    title: "Dodawanie pracownika",
    content:
      "W pełnej wersji tym przyciskiem dodajesz nowego pracownika. W demo formularz otworzy się normalnie - dopiero zapisanie pokaże informację, że to tylko prezentacja.",
    placement: "left",
  },
  {
    target: '[data-tour="employees-search"]',
    title: "Wyszukiwanie",
    content:
      "Szybkie wyszukiwanie po imieniu, nazwisku lub adresie email. Przydaje się, gdy zespół rośnie do kilkudziesięciu osób.",
    placement: "bottom",
  },
  {
    target: '[data-tour="employees-table"]',
    title: "Lista pracowników",
    content:
      "Kliknij w wiersz, aby otworzyć szczegóły pracownika: stawki godzinowe oraz dane pracownika.",
    placement: "top",
  },
  {
    target: '[data-tour="employees-row-actions"]',
    title: "Akcje na pracowniku",
    content:
      "Z tego menu wysyłasz zaproszenie do aplikacji oraz dezaktywujesz lub aktywujesz konto. Dezaktywacja nie usuwa historii - blokuje tylko logowanie i nowe przypisania.",
    placement: "left",
  },
];

export const LOCATION_DETAIL_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="add-room-btn"]',
    title: "Dodawanie sali",
    content: "Tu możesz dodać salę do lokalizacji.",
    placement: "bottom",
  },
  {
    target: '[data-tour="rooms-section"]',
    title: "Sale i grupy",
    content:
      "Możesz dodać grupę do konkretnej sali, lub dodać grupę bez sali - wtedy algorytm sam dobierze salę dla danego grafiku.",
    placement: "top",
  },
  {
    target: '[data-tour="workflow-stepper"]',
    title: "Następny etap",
    content: "Kliknij Przejdź dalej, aby przejść do następnego etapu.",
    placement: "right",
  },
];

export const SUBSTITUTIONS_REPORT_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="reports-header"]',
    title: "Raport zastępstw i niedostępności",
    content:
      "Analiza zgłoszeń zastępstw z danego miesiąca - ile było potrzeb, jak szybko je dopasowywano i którzy prowadzący generują ich najwięcej.",
    placement: "bottom",
  },
  {
    target: '[data-tour="substitutions-report-controls"]',
    title: "Wybór miesiąca i eksport",
    content:
      "Przełączaj miesiące strzałkami lub wybierz bezpośrednio z list. Przycisk XLSX pobiera pełen raport (w demo pobierzesz gotowy, przykładowy plik).",
    placement: "bottom",
  },
  {
    target: '[data-tour="substitutions-report-summary"]',
    title: "Karty podsumowania",
    content:
      "Kluczowe wskaźniki: liczba zgłoszeń, rozwiązanych, oczekujących oraz średni czas rozwiązania. Dzięki temu od razu widzisz skalę problemu z zastępstwami.",
    placement: "bottom",
  },
  {
    target: '[data-tour="substitutions-report-chart"]',
    title: "Rozkład statusów",
    content:
      "Wykres pokazuje proporcje zastępstw rozwiązanych, w toku, anulowanych i wygasłych. Pomaga dostrzec wąskie gardła procesu.",
    placement: "top",
  },
  {
    target: '[data-tour="substitutions-report-table"]',
    title: "Zestawienie prowadzących",
    content:
      "Tabela z liczbą zgłoszeń per prowadzący - w tym ile pochodzi z procesu odejść. Przydatne, żeby wychwycić osoby często wymagające zastępstw.",
    placement: "top",
  },
];

export const WORKLOAD_REPORT_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="reports-header"]',
    title: "Raport obciążenia prowadzących",
    content:
      "Zobacz ile godzin tygodniowo pracują prowadzący, kto jest przeciążony i kto często jeździ między lokalizacjami.",
    placement: "bottom",
  },
  {
    target: '[data-tour="workload-report-controls"]',
    title: "Wybór miesiąca i eksport",
    content:
      "Każdy miesiąc liczy się niezależnie. Eksport XLSX daje pełną tabelę do dalszej analizy (w demo dostępny jest gotowy, przykładowy plik).",
    placement: "bottom",
  },
  {
    target: '[data-tour="workload-report-summary"]',
    title: "Karty podsumowania",
    content:
      "Średnia tygodniowa godzin, liczba osób przeciążonych (>15h/tydz), łączna liczba zajęć i dni z wieloma lokalizacjami - szybki obraz stanu zespołu.",
    placement: "bottom",
  },
  {
    target: '[data-tour="workload-report-table"]',
    title: "Tabela obciążenia",
    content:
      "Per prowadzący: godziny, średnia tygodniowa (z kolorami - zielony/żółty/czerwony), zastępstwa, intensywność dnia i dojazdy między lokalizacjami. Czerwone wartości = sygnał do rozmowy.",
    placement: "top",
  },
];

export const COMMUNICATION_REPORT_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="reports-header"]',
    title: "Raport komunikacji",
    content:
      "Aktywność prowadzących w grupach czatowych z rodzicami - kto komunikuje się regularnie, a gdzie grupy \"milczą\".",
    placement: "bottom",
  },
  {
    target: '[data-tour="communication-report-controls"]',
    title: "Wybór miesiąca i eksport",
    content:
      "Przełączaj miesiące strzałkami lub listami. XLSX eksportuje pełne dane (w demo pobierzesz gotowy, przykładowy plik).",
    placement: "bottom",
  },
  {
    target: '[data-tour="communication-report-summary"]',
    title: "Karty podsumowania",
    content:
      "Łączna liczba wiadomości, załączników, aktywnych grup i prowadzących w komunikacji - szybki pomiar zaangażowania zespołu.",
    placement: "bottom",
  },
  {
    target: '[data-tour="communication-report-table"]',
    title: "Aktywność prowadzących",
    content:
      "Tabela pokazuje ile wiadomości i załączników wysłał każdy prowadzący oraz w ilu jego grupach toczyła się rozmowa. Procent aktywnych grup ma kolor (zielony >=70%, żółty >=30%, czerwony <30%).",
    placement: "top",
  },
];

export const CHAT_GROUP_TOUR_STEPS: TourStep[] = [
  {
    target: '[data-tour="chat-group-header"]',
    title: "Grupa czatowa",
    content:
      "To widok konkretnej grupy - prowadzący i przypisani rodzice. Stąd zarządzasz członkami i historią rozmowy.",
    placement: "bottom",
  },
  {
    target: '[data-tour="chat-group-members-btn"]',
    title: "Lista rodziców",
    content:
      "Rozwija panel z listą rodziców w grupie wraz z ich emailami. Przydatne do szybkiej weryfikacji kto jest członkiem.",
    placement: "bottom",
  },
  {
    target: '[data-tour="chat-group-add-parent-btn"]',
    title: "Dodawanie rodziców",
    content:
      "Zapraszasz rodziców po adresie email. W demo formularz otworzy się normalnie - dopiero zapisanie pokaże informację, że to tylko prezentacja.",
    placement: "bottom",
  },
  {
    target: '[data-tour="chat-group-actions-btn"]',
    title: "Akcje grupy",
    content:
      "Menu z dodatkowymi operacjami: edycja nazwy, eksport historii do XLSX, archiwizacja (ukrycie starszych wiadomości przed prowadzącym i rodzicami) oraz usunięcie grupy.",
    placement: "bottom",
  },
  {
    target: '[data-tour="chat-group-window"]',
    title: "Okno rozmowy",
    content:
      "W demo możesz pisać wiadomości, przypinać, reagować i korzystać z ogłoszeń oraz ankiet - wszystko działa na mockowych danych lokalnie. Poza demo administrator widzi rozmowę tylko w trybie podglądu.",
    placement: "top",
  },
];
